import React from "react";

interface AvatarProps {
  className: string;
  name?: string;
  profilePictureUrl?: string;
}

const initials = (name = "") =>
  name
    .split(" ")
    .map((part) => part[0])
    .join("")
    .slice(0, 2)
    .toUpperCase();

const Avatar = ({ className, name, profilePictureUrl }: AvatarProps) =>
  profilePictureUrl ? (
    <img
      className={className}
      src={profilePictureUrl}
      alt={`${name}'s profile`}
    />
  ) : (
    <div className={className} aria-hidden="true">
      {initials(name)}
    </div>
  );

export default Avatar;
